module.exports = __webpack_public_path__ + "img/SG.52564781.webp";